import type { FlyToOptions } from '@elfsight/widget-map';

export const MAP_WITH_CARD_OFFSET_X = 198;

export const FLY_TO_OPTIONS_WITH_CARD_OFFSET = {
  offset: [MAP_WITH_CARD_OFFSET_X, 0]
} satisfies FlyToOptions;
